/** FormData must go as multipart with a browser-generated boundary. */

export function isFormDataBody(data) {
  return typeof FormData !== 'undefined' && data instanceof FormData
}

export function unsetJsonContentType(headers) {
  if (!headers) return headers
  if (typeof headers.delete === 'function') {
    headers.delete('Content-Type')
    headers.delete('content-type')
    // axios AxiosHeaders: false = не подставлять дефолтный application/json
    if (typeof headers.set === 'function') {
      headers.set('Content-Type', false)
    }
    return headers
  }
  delete headers['Content-Type']
  delete headers['content-type']
  return headers
}

export function prepareFormDataRequest(config) {
  if (!config || !isFormDataBody(config.data)) return config
  unsetJsonContentType(config.headers)
  return config
}
